import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageACoruna = props => {
  return (
    <CityLandingPage
      cityKey="ACoruna"
      cityConfig={cityContent.aCoruna}
      cityLabel="aCoruna"
      {...props}
    />
  );
};

export default LandingPageACoruna;
